import { useEffect, useState } from 'react';
import { ArrowUp } from 'lucide-react';
import { IconButton } from '@anyemp/ui-kit';
import {
  scrollWindowToTop,
  shouldShowScrollToTop,
  subscribeToWindowScroll,
} from '../../utils/scrollToTop';

export default function ScrollToTopButton({ hidden = false }) {
  const [visible, setVisible] = useState(() => shouldShowScrollToTop(window.scrollY, hidden));

  useEffect(() => {
    const updateVisibility = () => setVisible(shouldShowScrollToTop(window.scrollY, hidden));

    updateVisibility();
    return subscribeToWindowScroll(window, updateVisibility);
  }, [hidden]);

  if (!visible) return null;

  return (
    <IconButton
      aria-label="Scroll to top"
      title="Scroll to top"
      onClick={() => scrollWindowToTop(window)}
      variant="filled"
      color="primary"
      size="large"
      sx="fixed bottom-20 right-5 z-30 rounded-full shadow-lg transition-transform duration-ui-normal ease-ui hover:scale-105 active:scale-95"
      icon={<ArrowUp size={22} aria-hidden="true" />}
    />
  );
}
